import type { LandingStrings } from './en';

export const ru: LandingStrings = {
  header: {
    brandSubtitle: 'Волшебная лавка',
    contact: 'Связаться',
    about: 'Об игре',
    language: 'Язык',
  },
  footer: {
    terms: 'Условия использования',
    privacy: 'Политика конфиденциальности',
    copyright: '{year} {holder}. Все права защищены.',
  },
  home: {
    heroTitle: 'Уютная 3D-игра про зелья и волшебную лавку.',
    heroDescription:
      'Ищи ингредиенты среди волшебного беспорядка, вари зелья в котле и продавай их в собственной лавке.',
    features: [
      {
        title: 'Свой флакон',
        desc: 'Форма, крышка и цвет зелья — нарядные флаконы продаются дороже.',
      },
      {
        title: 'Крафт со смыслом',
        desc: 'У каждого зелья свой рецепт, и многие по-настоящему работают в игре.',
      },
      {
        title: 'История, за которой интересно следить',
        desc: 'Бабушка уехала отдыхать и оставила тебе лавку, а лягушка по имени Морен требует своё.',
      },
      {
        title: 'Лавка, которая правда твоя',
        desc: 'Продаётся только то, что сварено твоими руками.',
      },
    ],
    appStore: 'App Store',
    googlePlay: 'Google Play',
    comingSoon: 'Скоро выходит',
    tags: { search: 'Поиск по теням', craft: '3D-варка зелий', shop: 'Уютная лавка' },
  },
  about: {
    title: 'Об игре Qevryno',
    intro: [
      'Добро пожаловать в Qevryno — уютную игру про варку зелий, где магия сделана руками.',
      'Бабушка уехала отдыхать и попросила тебя присмотреть за её таинственным старым домом: забытые рецепты, волшебные ингредиенты и котёл, который ещё помнит, как кипеть. Внизу — маленькая лавка, и вся деревня уже гадает, кто теперь за ней приглядывает.',
      'Вари зелья, заботься о пушистом фамильяре, продавай свои творения обаятельным покупателям и зарабатывай монеты на украшение волшебного дома — в своём темпе, без таймеров.',
    ],
    whatTitle: 'Что это за игра?',
    what: [
      'Qevryno — расслабляющая 3D-головоломка, в которой смешались поиск предметов, алхимический крафт и маленький симулятор лавки. Если любишь уютные игры, казуальные головоломки, поиск спрятанных предметов, игры про зелья, алхимию и собственный волшебный магазинчик — это она.',
      'Это одиночная игра, она работает без интернета; сеть нужна только для покупок и необязательных роликов за награду. Баннеров и всплывающей рекламы нет: короткий ролик Google AdMob за бонус идёт только по твоему нажатию. Необязательные покупки — кристаллы и наборы ингредиентов с видимым составом. Скоро выйдет на iOS и Android, на русском, английском, испанском, немецком, французском, нидерландском, итальянском, португальском (Бразилия), польском, японском, корейском, традиционном китайском и турецком языках.',
    ],
    doTitle: 'Чем ты будешь заниматься',
    doList: [
      'Искать спрятанные ингредиенты на волшебных 3D-полянах в лесу — каждая как маленькая диорама.',
      'Варить волшебные рецепты в котле: стабилизатор, основной ингредиент, травы времени и капля цвета.',
      'Оформлять собственные флаконы — форма, крышка, цвет зелья; нарядные продаются дороже.',
      'Вести свою лавку: покупатели, репутация, ярмарки и квесты.',
      'Следить за историей: бабушка уехала отдыхать и оставила тебе лавку, а лягушка по имени Морен всё требует своё.',
      'Растирать находки в ступке, смешивать в миске и добавлять блёстки — у каждой смеси своя фактура и цвет.',
      'Кормить фамильяра и украшать лавку.',
    ],
    faqTitle: 'Частые вопросы',
    faq: [
      { q: 'Qevryno бесплатная?', a: 'Да. Игра бесплатна, и в неё можно играть без платежей. Необязательные покупки — кристаллы и наборы ингредиентов.' },
      { q: 'Работает без интернета?', a: 'Да. Самой игре сеть не нужна — вари зелья в самолёте или под пледом. Интернет нужен только для покупок и необязательных роликов за награду.' },
      { q: 'Есть реклама?', a: 'Только необязательная. Баннеров и всплывающей рекламы между экранами нет. В нескольких местах можно по желанию посмотреть короткий ролик и получить бонус — например, ману. Ничто в игре не требует их смотреть. Ролики показывает Google AdMob; подробности — в Политике конфиденциальности.' },
      { q: 'На каких платформах?', a: 'iOS и Android, на русском, английском, испанском, немецком, французском, нидерландском, итальянском, португальском (Бразилия), польском, японском, корейском, традиционном китайском и турецком языках.' },
      { q: 'Она страшная или напряжённая?', a: 'Совсем нет. Спокойная уютная игра: мягкая музыка, никаких наказаний за ошибки и кот в шляпе.' },
    ],
  },
  contact: {
    title: 'Связаться с нами',
    subtitle: 'Вопрос о Qevryno, ошибка, покупка или реклама? Напиши нам на почту.',
    write: 'Написать письмо',
    mailSubject: 'Qevryno: поддержка',
    tip: 'Напиши, какое у тебя устройство и что случилось, — так проще помочь.',
    info: {
      title: 'Контакты',
      email: 'Почта',
      security: 'Безопасность',
      legalName: 'Разработчик',
      address: 'Адрес',
    },
    refunds: {
      title: 'Возвраты и покупки',
      description: 'Все покупки проходят через Apple App Store или Google Play. Чтобы вернуть деньги, обратись в магазин:',
      apple: 'Apple App Store',
      appleUrl: 'https://support.apple.com/ru-ru/HT204084',
      google: 'Google Play',
      googleUrl: 'https://support.google.com/googleplay/answer/2479637?hl=ru',
      link: 'Запросить возврат',
      note: 'Сами мы платежи не принимаем и вернуть деньги не можем. Если покупка не пришла в игру, открой «Настройки → Восстановить покупки» или напиши нам.',
    },
  },
  legal: {
    dataController: 'Оператор данных',
    // Политика и условия есть на английском, русском и испанском; для остальных языков страница показывает английский текст и эту строку
    onlyIn: '',
  },
};
